const RideOption = {
  RideOption: 'Vehicle Type',
  addRideOption: 'Add Vehicle Type',
  editRideOption: 'Edit Vehicle Type',
};
export default RideOption;
